// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"tf_a bic_b bic_bj","HomeBaseBanner__hint":"tf_b bic_vh","HomeBaseBanner__link":"tf_c"};